import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { MUSIC24_TRIAL_DAYS, MUSIC24_TRIAL_LEVEL_TIER } from 'fym-shared/src/music24/music24Plans';
import { planNameMessages } from '../../../music24/config/music24PlanNames';
import { MUSIC24_PLANS } from '../../../music24/config/music24StripePlans';
import { formatPlanPrice, useDisplayCurrency } from '../../../music24/config/useDisplayCurrency';

export interface AuthTrialFacts {
  days: number;
  plan: string;
  /** The lowest monthly price of a paid plan in the shown currency, for example "$19" or "€19". */
  price: string;
}

/**
 * The numbers of the trial line (design: onboarding g1, g10). They come from the plan files, never
 * from the copy: the trial days, the name of the plan the trial gives and the lowest paid price.
 * The price comes from the plan table and shows in the currency of `useDisplayCurrency`.
 */
export function useAuthTrialFacts(): AuthTrialFacts {
  const intl = useIntl();
  // The same currency as the plans page and the upgrade offer (QA 2026-10-24 D12, F04).
  const currency = useDisplayCurrency();
  return useMemo(() => {
    const lowestCents = Math.min(...MUSIC24_PLANS.map((plan) => plan.prices.monthly.amount));
    return {
      days: MUSIC24_TRIAL_DAYS,
      plan: intl.formatMessage(planNameMessages[MUSIC24_TRIAL_LEVEL_TIER]),
      price: formatPlanPrice(intl, lowestCents, currency),
    };
  }, [currency, intl]);
}
